import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ContractFounder } from '../classes/contractFounder';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class ContractFounderService {
    API_CONTRACT_FOUNDER_URL = config.serverAddress + ':' + config.serverPort + '/contract-founder/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get(this.API_CONTRACT_FOUNDER_URL + 'all');
    }
    getByID(id: string) {
        return this.http.get(this.API_CONTRACT_FOUNDER_URL + id);
    }
    create(contractFounder: ContractFounder) {
        return this.http.post(this.API_CONTRACT_FOUNDER_URL + 'create', contractFounder);
    }
    update(contractFounder: ContractFounder) {
        return this.http.put(this.API_CONTRACT_FOUNDER_URL + 'update', contractFounder);
    }
    delete(id: number) {
        return this.http.delete(this.API_CONTRACT_FOUNDER_URL + 'delete/' + id);
    }
}